import { Theme, Typography, styled } from '@material-ui/core';
import { ProfilePicture } from 'src/modules/shared/components';

export const VideoProgressWrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  background: theme.palette.common.white,
}));

export const Row = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const Col = styled('div')<Theme>(({ theme }) => ({
  flexBasis: '25%',
  textAlign: 'center',
  '&.average': {
    fontWeight: 700,
  },
}));

export const UserName = styled(Col)({
  display: 'flex',
  textAlign: 'left',
  flexBasis: '50%',
  fontSize: '1.4rem',
});

export const AverageTitle = styled(Typography)({
  flexBasis: '50%',
});

export const AverageRow = styled(Row)<Theme>(({ theme }) => ({
  borderTop: theme.config.defaultBorder(theme.palette.grey['100']),
  paddingTop: theme.spacing(1, 2),
}));

export const AnswersLabel = styled('div')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
  marginBottom: theme.spacing(2),
  flexBasis: '50%',
}));

export const StyledProfilePicture = styled(ProfilePicture)<Theme>(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const Label = styled('span')<Theme>(({ theme }) => ({
  color: theme.palette.grey['700'],
}));
